import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-751acfda"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left-edge"
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dashed-line"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right-edge"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dot_element = _resolveComponent("dot-element");
  return _openBlock(), _createElementBlock("div", _mergeProps({
    ref: "bar",
    class: "bar"
  }, _ctx.$attrs), [_hoisted_1, _hoisted_2, _hoisted_3, $data.position ? (_openBlock(), _createBlock(_component_dot_element, {
    key: 0,
    size: 8,
    color: $props.color,
    class: "dot",
    style: _normalizeStyle({
      left: `${$data.position}px`
    })
  }, null, 8, ["color", "style"])) : _createCommentVNode("", true)], 16);
}